export const selectedTemplateIdKey = (groupId: string) => `_baas.selected-template-id-${groupId}`;
